import { defineComponent } from "vue";
import { maska } from "maska";

export default defineComponent({
  directives: { maska },
  emits: ["update:modelValue", "blur", "focus", "change", "keyup", "keydown"],
  props: {
    modelValue: {
      type: String,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    mask: {
      type: String,
    },
    inputmode: {
      type: String,
    },
    validatorType: {
      type: Array,
    },
    validatorParams: {
      default: null,
    },
    customErrorMsg: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    autocapitalize: {
      type: String,
    },
    iconAfter: {
      type: Boolean,
    },
    forceError: {
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    requiredSign: {
      type: Boolean,
      default: false,
    },
    removeMessages: {
      default: false,
      type: Boolean,
    },
    maxLength: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      hasError: false,
      errorMsg: "",
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value: any) {
         if (!value) {
          this.$emit("update:modelValue", "");
          return;
        }

        let sanitizedValue = value.replace(/<[^>]*>?/gm, "");
        sanitizedValue = sanitizedValue.replace(/[<>]/g, "");
        sanitizedValue = sanitizedValue.slice(0, this.maxLength);
        
        this.$emit("update:modelValue", value);
        this.hasError = false;
      },
    },
  },
  watch: {
    forceError(newValue) {
      this.hasError = newValue;
    },
    removeMessages() {
      this.hasError = false;
    },
  },
  methods: {
    compositionUpdate(event: any) {
      this.value = event.data;
    },
  },
});
